var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotConnectedRinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 6,
    fill: "#DF5A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1603 9.8397C18.0407 6.7201 12.9632 6.7201 9.84356 9.8397C8.33241 11.3514 7.5 13.3609 7.5 15.4981C7.5 17.6352 8.33241 19.6447 9.84356 21.1558C11.4037 22.716 13.4528 23.4957 15.5019 23.4957C17.551 23.4957 19.6002 22.716 21.1603 21.1558C24.2799 18.0363 24.2799 12.9599 21.1603 9.8397ZM20.2839 20.2794C17.6471 22.9161 13.3567 22.9161 10.72 20.2794C9.44315 19.0026 8.73964 17.3042 8.73964 15.4981C8.73964 13.6919 9.44315 11.9936 10.72 10.7161C13.3567 8.07937 17.6471 8.07999 20.2839 10.7161C22.92 13.3529 22.92 17.6433 20.2839 20.2794Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1728 17.2113L16.418 15.459L18.1728 13.7068C18.4145 13.4651 18.4145 13.0727 18.1734 12.8304C17.9311 12.5874 17.5387 12.588 17.2964 12.8297L15.5404 14.5832L13.7844 12.8297C13.5421 12.588 13.1498 12.5874 12.9074 12.8304C12.6657 13.0727 12.6657 13.4651 12.908 13.7068L14.6628 15.459L12.908 17.2113C12.6657 17.453 12.6657 17.8453 12.9074 18.0877C13.0283 18.2092 13.1876 18.2693 13.3463 18.2693C13.5049 18.2693 13.6636 18.2086 13.7845 18.0883L15.5404 16.3348L17.2964 18.0883C17.4173 18.2092 17.5759 18.2693 17.7346 18.2693C17.8933 18.2693 18.0526 18.2086 18.1735 18.0877C18.4151 17.8453 18.4151 17.453 18.1728 17.2113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedRinsIcon);
export default __webpack_public_path__ + "static/media/not_connected_rins_icon.83b1df923125414aa2827feb18e9623a.svg";
export { ForwardRef as ReactComponent };